export default __webpack_public_path__ + "static/media/folder.3239f9f0.svg";